import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { BannerNotificationActions } from '@ninety/platform/state/app-global/banner-notification/banner-notification.actions';
import { BannerNotificationModel } from '@ninety/platform/state/app-global/banner-notification/banner-notification.model';
import { BannerStateSelectors } from '@ninety/platform/state/app-global/banner-notification/banner-notification.selectors';
import { selectIsBillingV3Company } from '@ninety/platform/state/app-global/company/company-state.selectors';
import {
  BANNER_DISMISSED,
  BannerDismissedHandler,
  IS_BILLING_V3_COMPANY_STREAM,
  NOTIFICATION_BANNER_STREAM,
} from '@ninety/ui/core';

/**
 * Binds the tokens consumed by `NotificationBannerComponent` in `@ninety/ui/core` to the banner and
 * company slices of `@ninety/platform/state`, inverting the component's former direct store
 * reads and dispatches. `@ninety/platform/state` has no build target and so cannot be compiled into the
 * public package; this composition-root wiring is the single place that depends on both sides. The
 * banner's "open pricing plans" action reuses the existing `OPEN_PRICING_PLANS_MODAL` token, already
 * bound in `billing-dialog.providers.ts`. (DEV-26530 part 15)
 */
export const NOTIFICATION_BANNER_PROVIDERS: Provider[] = [
  {
    provide: NOTIFICATION_BANNER_STREAM,
    useFactory: (store: Store) => store.select(BannerStateSelectors.selectMessage),
    deps: [Store],
  },
  {
    provide: IS_BILLING_V3_COMPANY_STREAM,
    useFactory: (store: Store) => store.select(selectIsBillingV3Company),
    deps: [Store],
  },
  {
    provide: BANNER_DISMISSED,
    useFactory:
      (store: Store): BannerDismissedHandler =>
      banner =>
        store.dispatch(BannerNotificationActions.dismissBanner({ banner: banner as BannerNotificationModel })),
    deps: [Store],
  },
];
